const globalConfig = {
    computed: {
      config_FrontendUrl() {
        return this.$store.state.config.runtime?.FrontendUrl || "";
      },
      config_WebApiUrl() {
        return this.$store.state.config.runtime?.WebApiUrl || "";
      },
      config_GoogleTagId() {
        return this.$store.state.config.runtime?.GoogleTagId || "";
      },
      config_BackgroundColor() {
        return this.$store.state.config.runtime?.BackgroundColor || "";
      },
      config_MaxReachDays() {
        return this.$store.state.config.runtime?.MaxReachDays || "";
      },
      config_ShowCampaignTab() {
        return this.$store.state.config.runtime?.ShowCampaignTab;
      },
      config_ShowProgramConsumptionTab() {
        return this.$store.state.config.runtime?.ShowProgramConsumptionTab;
      },
      config_ShowGrouping() {
        return this.$store.state.config.runtime?.ShowGrouping || "";
      },
      config_ApplicationHeading() {
        return this.$store.state.config.runtime?.ApplicationHeading || "";
      },
      config_ApplicationSubHeading() {
        return this.$store.state.config.runtime?.ApplicationSubHeading || "";
      },
      config_ShowTRP() {
        return this.$store.state.config.runtime?.ShowTRP;
      },
      config_LinkTvAnalys() {
        return this.$store.state.config.runtime?.LinkTvAnalys || "";
      },
      config_LinkTotalanalys() {
        return this.$store.state.config.runtime?.LinkTotalanalys || "";
      },
      config_LinkDataPortal() {
        return this.$store.state.config.runtime?.LinkDataPortal || "";
      },
      config_MiniumClientVersion() {
        return this.$store.state.config.runtime?.MiniumClientVersion || "";
      },
      config_CurrentClientVersion() {
        return this.$store.state.config.runtime?.CurrentClientVersion || "";
      },
      config_AppCookieDomain() {
        return this.$store.state.config.runtime?.AppCookieDomain || "";
      },
      config_AuthCookieDomain() {
        return this.$store.state.config.runtime?.AuthCookieDomain || "";
      },
      config_WebCaatAuthWebUrl() {
        return this.$store.state.config.runtime?.WebCaatAuthWebUrl || "";
      },
      config_NumberOfTargetGroupsProgram() {
        return this.$store.state.config.runtime?.NumberOfTargetGroupsProgram || "";
      },
      config_NumberOfTargetGroupsAd() {
        return this.$store.state.config.runtime?.NumberOfTargetGroupsAd || "";
      },
      config_NumberOfTargetGroupsChannel() {
        return this.$store.state.config.runtime?.NumberOfTargetGroupsChannel || "";
      },
      config_ShowFilmType() {
        return this.$store.state.config.runtime?.ShowFilmType;
      },
    },
  };
  
  export default globalConfig;
  